/**
 * Domain/company information utilities
 */

const DEFAULT_LOGO = "/assets/logo.svg"

/**
 * Checks if current environment is development
 */
export const isDevelopmentEnvironment = (): boolean => {
  const currentHost = window.location.hostname
  return import.meta.env.DEV || currentHost === "localhost"
}

/**
 * Gets subdomain from current hostname
 */
export const getSubdomain = (): string | null => {
  const currentHost = window.location.hostname
  const hostParts = currentHost.split(".")

  if (hostParts.length < 2) {
    return null
  }

  return hostParts[0]
}

/**
 * Formats logo URL from API response
 */
export const formatLogoUrl = (logo: string | null | undefined): string => {
  if (!logo || logo.trim() === "") {
    return DEFAULT_LOGO
  }

  if (logo.startsWith("http")) {
    return logo
  }

  return `${import.meta.env.VITE_API_URL || 'http://localhost:8000'}${logo}`
}

/**
 * Gets default logo for development/special cases
 */
export const getDefaultLogo = (): string => {
  return DEFAULT_LOGO
}
